module.exports = __webpack_public_path__ + "img/dot-blue.e1ff1c42.svg";